export function showLiveChat() {
    try {
        window.zoomCampaignSdk?.show?.();
    } catch (e) {
        /* engagement open */
    }
    document.getElementById('genesys-messenger')?.classList.remove('d-none');
}

export function hideLiveChat() {
    try {
        window.zoomCampaignSdk?.hide?.();
    } catch (e) {
        /* engagement open */
    }
    document.getElementById('genesys-messenger')?.classList.add('d-none');
}

export function isLiveChatReady() {
    return Boolean(window.zoomCampaignSdk) || Boolean(document.getElementById('genesys-messenger'));
}
